<template>
    <div class="base-form-div">
        <el-form size="mini" :model="ruleForm" :rules="rules" ref="ruleForm" label-width="100px" class="demo-ruleForm">
            <el-form-item label="名称" prop="name">
                <el-input placeholder="请输入设备名称" v-model="ruleForm.name"></el-input>
            </el-form-item>
            <el-form-item label="北斗卡号" prop="cardNumber">
                <el-input placeholder="请输入北斗卡号" v-model="ruleForm.cardNumber"></el-input>
            </el-form-item>
            <el-form-item label="所属分组" prop="deviceGroupId">
                <el-cascader @change="handleChange" v-model="ruleForm.deviceGroupId" placeholder="请选择所属分组"
                    :options="groupList" :props="{ checkStrictly: true, expandTrigger: 'hover', emitPath: false }"
                    clearable></el-cascader>
                <!-- <el-select v-model="ruleForm.deviceGroupId" placeholder="请选择所属分组">
                    <el-option v-for="item in groupList" :key="item.value" :label="item.label" :value="item.value">
                    </el-option>
                </el-select> -->
            </el-form-item>
            <div class="form-bottom">
                <el-button class="base-button" size="mini" type="primary" @click="submitForm('ruleForm')">确定</el-button>
                <el-button class="base-button" size="mini" @click="resetForm('ruleForm')">重置</el-button>
            </div>
        </el-form>
    </div>
</template>
<script>
import { iViewCascadeDeviceGroup, updateDevice } from "@/api/device/index.js"
export default {
    props: ["subData"],
    data() {
        return {
            groupList: [],
            id: undefined,
            node: undefined,
            parentName: undefined,
            ruleForm: {
                cardNumber: "",
                deviceGroupId: ""
            },
            rules: {
                name: [
                    { required: true, message: "请输入设备名称", trigger: "blur" }
                ],
                cardNumber: [
                    { required: true, message: "请输入北斗卡号", trigger: "blur" }
                ],
                deviceGroupId: [
                    { required: true, message: "请选择所属分组", trigger: "change" },
                ]
            },
        };
    },
    methods: {
        handleChange(val) {
            console.log(val);
            console.log(this.ruleForm);
        },
        submitForm(formName) {
            console.log(this.ruleForm);
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    updateDevice(this.ruleForm).then(() => {
                        this.$message({
                            message: "修改成功",
                            type: "success",
                        });
                        this.$bus.$emit("device-list");
                        this.$parent.close();
                    });
                } else {
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
        deleteChildren(list) {
            list.forEach((item) => {
                if (item.children && item.children.length < 1) {
                    delete item.children;
                }
                else {
                    this.deleteChildren(item.children);
                }
            });
        },
        async initPids() {
            var res = await iViewCascadeDeviceGroup();
            this.groupList = res.result || [];
            this.deleteChildren(this.groupList);
        },
    },
    async created() {
        await this.initPids();
        this.ruleForm = this.subData;
        this.ruleForm.deviceGroupId = this.subData.deviceGroupId + '';
    },
    mounted() { },
};
</script>
<style>
.form-bottom {
    margin-bottom: 0 !important;
    text-align: center;
}

.el-input-number {
    width: 100%;
}
</style>